module.exports = __webpack_public_path__ + "img/Sarmayeh.7338a2ba.svg";